module.exports = __webpack_public_path__ + "static/media/AB_K25_3.85fcd93d.jpg";